// SettingsStore
// -------------
// A layer for user settings.
// Uses localStorage with safe JSON parsing.
// Automatically merges defaults and stored values.

export class SettingsStore {
  constructor() {
    this.key = "slideshow-settings-v1";

    this.defaults = {
      fit: false,
      includeSubdirs: false,
      autoShuffle: false,
      intervalSeconds: 3,
      layoutId: "single",
      autoRandomLayout: false,
      autoPlay: false,
    };

    this.data = this._load();
  }

  // ------------------------------------------------------------
  // Load + merge defaults
  // ------------------------------------------------------------
  _load() {
    try {
      const raw = localStorage.getItem(this.key);
      if (!raw) return { ...this.defaults };

      const parsed = JSON.parse(raw);
      return { ...this.defaults, ...parsed };
    } catch (err) {
      console.warn("SettingsStore: failed to parse settings, resetting.");
      return { ...this.defaults };
    }
  }

  // ------------------------------------------------------------
  // Save
  // ------------------------------------------------------------
  _save() {
    try {
      localStorage.setItem(this.key, JSON.stringify(this.data));
    } catch (err) {
      console.warn("SettingsStore: failed to save settings.", err);
    }
  }

  // ------------------------------------------------------------
  // Getters + setters
  // ------------------------------------------------------------
  get includeSubdirs() {
    return this.data.includeSubdirs;
  }
  set includeSubdirs(v) {
    this.data.includeSubdirs = v;
    this._save();
  }

  get fit() {
    return this.data.fit;
  }

  set fit(v) {
    this.data.fit = v;
    this._save();
  }

  get intervalSeconds() {
    return this.data.intervalSeconds;
  }
  set intervalSeconds(v) {
    this.data.intervalSeconds = v;
    this._save();
  }

  get layoutId() {
    return this.data.layoutId;
  }
  set layoutId(v) {
    this.data.layoutId = v;
    this._save();
  }

  get autoRandomLayout() {
    return this.data.autoRandomLayout;
  }
  set autoRandomLayout(v) {
    this.data.autoRandomLayout = v;
    this._save();
  }

  get autoPlay() {
    return this.data.autoPlay;
  }
  set autoPlay(v) {
    this.data.autoPlay = v;
    this._save();
  }

  set autoShuffle(v) {
    this.data.autoShuffle = v;
    this._save();
  }
  get autoShuffle() {
    return this.data.autoShuffle;
  }
}
